export default async function GetOwnerTransactionsfilter({ projectId = 0,
    investorId = 0,
    fromdate = null,
    todate = null,
    transstatus = 1 } = {}) {
    // let url = window.RealestateService+  `/api/PaymentDetails/GetProjectWiseInvestorPaymentDetails`
    const params = new URLSearchParams();
    

    if (projectId) params.append("projectId", projectId);
    if (investorId) params.append("investorId", investorId);
    if (fromdate) params.append("fromdate", fromdate); // yyyy-mm-dd
    if (todate) params.append("todate", todate);       // yyyy-mm-dd
    if (transstatus) params.append("transstatus", transstatus);       // yyyy-mm-dd

    const url =
        window.RealestateService+`/api/PaymentDetails/GetProjectWiseOwnerPaymentDetailswithdaterange?${params.toString()}`;
    let head = {
        "content-type": "application/json",
        "accept": "*/*"
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
    }).then(res => res.json()).catch(res => res)

    return response
}